import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import Switch from "flarum/common/components/Switch";
export default function () {
  extend("flarum/forum/components/SettingsPage", "settingsItems", function (items) {
    const user = this.user;
    if (!user || app.forum.attribute("profileVisibilityMode") === "admin") return;
    const audience = app.forum.attribute("profilePrivacyAudience") === "members" ? "members" : "private";
    items.add("profileVisibility", m("div", {
      className: "Form-group PrivateProfile-setting"
    }, m("label", null, app.translator.trans("huseyinfiliz-private-profile.forum.user.settings.private_profile_heading")), m(Switch, {
      state: user.attribute("privateProfileEnabled"),
      disabled: this.privateProfileLoading,
      loading: this.privateProfileLoading,
      onchange: value => {
        this.privateProfileLoading = true;
        user.savePreferences({
          privateProfileEnabled: value
        }).catch(() => {}).finally(() => {
          this.privateProfileLoading = false;
          m.redraw();
        });
      }
    }, app.translator.trans("huseyinfiliz-private-profile.forum.user.settings.private_profile_description")), m("div", {
      className: "helpText"
    }, app.translator.trans(`huseyinfiliz-private-profile.forum.user.settings.private_profile_help_${audience}`)), m("div", {
      className: "helpText"
    }, app.translator.trans("huseyinfiliz-private-profile.forum.user.settings.private_profile_help_public"))));
  });
}